import {RestResource} from '../rest'
import {KPI_SERVER} from '../server'
import {athubAxios} from '../../util'

const kpiRecord = new RestResource({server: KPI_SERVER, resource: 'kpirecord'});

export default kpiRecord;